import { connect } from "react-redux";
import Component from "./View";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/ipm-shared/store/model/selectors";

import * as actions from "src/ipm-shared/store/model/actions";

const mapStateToProps = (state: RootState, props: any) => ({
  extraInfo: selectors.getExtraInfo(state, props.modalId)
});

const mapDispatchToProps = {
  toggleModal: actions.toggleModal
};

// Fixed template
export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
